import { jsxs as d, jsx as t } from "react/jsx-runtime";
import * as p from "react";
import { useState as f, useCallback as l, useEffect as v } from "react";
import { InputLabelWrapper as B } from "../shared/input-label-wrapper/InputLabelWrapper.component.js";
import { S as R } from "../down-arrow-CNVCC5Vu.js";
import { Button as k } from "../shared/button/Button.component.js";
import { ButtonThemeEnum as w, ButtonSizeEnum as _ } from "../shared/button/types.js";
import { c as g } from "../index-C3-ZVs5E.js";
import { FlowRunLogs as N } from "./FlowRunLogs.component.js";
import { Checkbox as F } from "../shared/checkbox/Checkbox.component.js";
import '../assets/FlowRuns.css';const H = "_refreshButton_a2ktv_2", L = "_container_a2ktv_8", I = "_header_a2ktv_8", b = "_flowRunHeader_a2ktv_16", E = "_flowRunHeaderButtons_a2ktv_26", S = "_expandButton_a2ktv_32", j = "_expandIcon_a2ktv_36", z = "_expanded_a2ktv_39", n = {
  refreshButton: H,
  container: L,
  header: I,
  flowRunHeader: b,
  flowRunHeaderButtons: E,
  expandButton: S,
  expandIcon: j,
  expanded: z
}, x = (e) => /* @__PURE__ */ p.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ p.createElement("path", { d: "M16.9413 10.9136C16.7761 12.1736 16.271 13.3649 15.4801 14.3597C14.6893 15.3544 13.6426 16.1152 12.4523 16.5603C11.262 17.0054 9.97295 17.1181 8.72345 16.8863C7.47396 16.6545 6.31113 16.0869 5.35968 15.2445C4.40824 14.402 3.70406 13.3165 3.32268 12.1042C2.9413 10.892 2.8971 9.59878 3.19482 8.36333C3.49254 7.12788 4.12095 5.99678 5.01266 5.09133C5.90437 4.18588 7.02573 3.54025 8.25648 3.22367C11.6683 2.34862 15.2 4.10484 16.5038 7.37752", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ p.createElement("path", { d: "M17.0002 3.00195V7.37719H12.625", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), D = ({
  flowRun: e,
  onClick: c,
  isExpanded: a,
  queryFlowRunLogs: i
}) => {
  const [u, m] = f(0), r = l(() => {
    c(e.id);
  }, [e.id, c]), h = l(() => {
    m((s) => s + 1);
  }, []);
  return /* @__PURE__ */ d("div", { className: n.flowRun, children: [
    /* @__PURE__ */ d("div", { className: n.flowRunHeader, children: [
      new Date(e.createdAt ?? "").toLocaleDateString() + " " + new Date(e.createdAt ?? "").toLocaleTimeString(),
      /* @__PURE__ */ d("div", { className: n.flowRunHeaderButtons, children: [
        a && /* @__PURE__ */ t(
          k,
          {
            size: _.md,
            theme: w.naked,
            className: n.refreshButton,
            onClick: h,
            children: /* @__PURE__ */ t(x, {})
          }
        ),
        /* @__PURE__ */ t(
          k,
          {
            size: _.xs,
            theme: w.naked,
            className: n.expandButton,
            onClick: r,
            children: /* @__PURE__ */ t(
              R,
              {
                className: g(n.expandIcon, {
                  [n.expanded]: a
                })
              }
            )
          }
        )
      ] })
    ] }),
    a && /* @__PURE__ */ t(
      N,
      {
        flowRunId: e.id,
        queryFlowRunLogs: i,
        fetchKey: u
      }
    )
  ] }, e.id);
}, O = ({
  queryFlowRuns: e,
  queryFlowRunLogs: c,
  isDebuggingEnabled: a,
  onEnableDebugging: i
}) => {
  const [u, m] = f([]), [r, h] = f(
    null
  ), s = l(async () => {
    const o = await e();
    m(o);
  }, [e]);
  v(() => {
    s();
  }, [s]);
  const C = l(
    (o) => {
      h(r === o ? null : o);
    },
    [r]
  );
  return /* @__PURE__ */ d("div", { className: n.container, children: [
    /* @__PURE__ */ d("div", { className: n.header, children: [
      /* @__PURE__ */ t(
        F,
        {
          label: "Enable debugging",
          checked: a,
          onChange: i
        }
      ),
      /* @__PURE__ */ t(
        k,
        {
          size: _.md,
          theme: w.naked,
          className: n.refreshButton,
          onClick: s,
          children: /* @__PURE__ */ t(x, {})
        }
      )
    ] }),
    /* @__PURE__ */ t(B, { labelText: "Flow Runs", id: "flowRuns", children: u.map((o) => /* @__PURE__ */ t(
      D,
      {
        flowRun: o,
        isExpanded: r === o.id,
        onClick: C,
        queryFlowRunLogs: c
      },
      o.id
    )) })
  ] });
};
export {
  O as FlowRuns
};
